<script setup lang="ts">
import { useSpace } from "@/api/space-query";
import { LinkButton } from "@soft-db/ui";

const props = defineProps<{
	spaceId: string;
}>();

const { space } = useSpace(() => props.spaceId);
</script>

<template>
	<LinkButton
		v-if="space"
		variant="ghost"
		color="primary"
		size="xs"
		:to="{
			name: 'spaces-id',
			params: { id: space.id },
		}"
	>
		{{ space.name }}
	</LinkButton>
</template>
